<template>
  <div>
    <section-page
      title="Appointment Reminders"
      description=""
    >
      <div class="appointment_setting--subheader">
        <h3 class="appointment_setting--subheading">Contact Settings</h3>
        <p class="appointment_setting--description">These are the default contact settings that will be used when you
          create appointments. You will be able to override them when you create an appointment.</p>
      </div>

      <div class="flex mb-100 flex-between flex-vertical-end">
        <form-field-time-in-minutes
          class="mb-0 flex-grow"
          label="Time Before Sending"
          v-model="form.time_before_contact_reminders"
          :validation-errors="validationErrors.time_before_contact_reminders"
        ></form-field-time-in-minutes>

        <div class="flex ml-300">
          <form-field-switch
            class="mb-25 mr-100"
            label="Send Text Reminders to Contacts"
            v-model="form.send_contact_text_reminder"
            :validation-errors="validationErrors.send_contact_text_reminder"
            size=""
          ></form-field-switch>

          <form-field-switch
            class="mb-25"
            label="Send Email Reminders to Contacts"
            v-model="form.send_contact_email_reminder"
            :validation-errors="validationErrors.send_contact_email_reminder"
            size=""
          ></form-field-switch>
        </div>
      </div>

      <grid-row>
        <grid-column v-show="form.send_contact_text_reminder" :size="6">
          <form-field-editor
            label="Text Reminder Message"
            v-model="form.contact_text_reminder"
            :validation-errors="validationErrors.contact_text_reminder"
            short-code-type="record"
            type="textContactWithRecord"
          ></form-field-editor>
        </grid-column>
        <grid-column v-show="form.send_contact_email_reminder" :size="6">
          <form-field-editor
            label="Email Reminder Message"
            v-model="form.contact_email_reminder"
            :validation-errors="validationErrors.contact_email_reminder"
            short-code-type="record"
            type="email"
          ></form-field-editor>
        </grid-column>
      </grid-row>

      <div class="appointment_setting--subheader">
        <h3 class="appointment_setting--subheading">User Settings</h3>
        <p class="appointment_setting--description">These are the default user settings that will be used when you
          create appointments. You will be able to override them when you create an appointment. NOTE: Each user decides
          when they want to get the notification in their profile.</p>
      </div>

      <grid-row>
        <grid-column :size="6">
          <form-field-editor
            label="Text Reminder Message"
            v-model="form.user_text_reminder"
            :validation-errors="validationErrors.user_text_reminder"
            type="textContactWithRecord"
            short-code-type="record"
          ></form-field-editor>
        </grid-column>

        <grid-column :size="6">
          <form-field-editor
            label="Email Reminder Message"
            v-model="form.user_email_reminder"
            :validation-errors="validationErrors.user_email_reminder"
            type="email"
            short-code-type="record"
          ></form-field-editor>
        </grid-column>
      </grid-row>

      <div class="flex flex-end">
        <button-outlined
          @click="save"
          :loading="saving"
          :disabled="saving"
          size=""
        >Save Appointment Settings
        </button-outlined>
      </div>
    </section-page>
  </div>
</template>

<script>
export default {
  name: "GeneralTab",
  data() {
    return {
      saving: false,
      form: {
        time_before_contact_reminders: null,
        send_contact_text_reminder: false,
        contact_text_reminder: "",
        send_contact_email_reminder: false,
        contact_email_reminder: "",
        user_text_reminder: "",
        user_email_reminder: "",
      },
      validationErrors: {}
    };
  },
  created() {
    this.form = {
      time_before_contact_reminders: this.account.time_before_contact_reminders,
      send_contact_text_reminder: this.account.send_contact_text_reminder,
      contact_text_reminder: this.account.contact_text_reminder,
      send_contact_email_reminder: this.account.send_contact_email_reminder,
      contact_email_reminder: this.account.contact_email_reminder,
      user_text_reminder: this.account.user_text_reminder,
      user_email_reminder: this.account.user_email_reminder,
    };
  },
  computed: {
    account() {
      return this.$store.getters.account;
    },
  },
  methods: {
    save() {
      this.saving = true;
      this.$api.accounts.updateAppointmentSettings(this.account.id, this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Appointment Defaults were saved",
            type: "is-success"
          });
        })
        .finally(() => this.saving = false);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.appointment_setting--subheader {
  margin-top: 2rem;
  margin-bottom: 1.5rem;
}

.appointment_setting--subheading {
  margin-bottom: 10px;
  font-size: 1.25rem;
  font-weight: bold;
  color: $text-light;
}

.appointment_setting--description {
  max-width: 800px;
  line-height: 1.4;
}
</style>
